<div *ngIf="pages?.length > 1" class="ui centered grid">
    <div class="center aligned column">
      <div class="ui pagination menu">
        <a (click)="previousPage()" class="icon item">
          <i class="left chevron icon"></i>
        </a>
        <a *ngFor="let page of pageArray; let i=index" (click)="setPage(page)" class="item" [class.active]="page == currentPageNum">{{ page === -1 ? '...' : page + 1 }}</a>
        <a (click)="nextPage()" class="icon item">
          <i class="right chevron icon"></i>
        </a>
      </div>
    </div>
</div>
